import React from "react"
import PropTypes from "prop-types"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import HorizontalCard from "./HorizontalCard"

const HorizontalCardLayout = ({ cards }) => {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  return (
    <Slider {...settings}>
      {cards.map((card, index) => (
        <div key={index}>
          <HorizontalCard data={card} />
        </div>
      ))}
    </Slider>
  )
}

HorizontalCardLayout.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
}

export default HorizontalCardLayout
